import React, { useState } from "react";
import { Box, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import Skeleton from "react-loading-skeleton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import 'react-loading-skeleton/dist/skeleton.css'
const CustomTextField = ({
    label,
    type,
    placeholder,
    name,
    value,
    onBlur,
    onKeyUp,
    errors,
    onChange,
    isLoading,
    rows,
    multiline,
    min,
    inputMode,
    pattern,
    onKeyDown,
    sx = {},
    disabled,
    style = {},
    max,
    required
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Typography
                sx={{
                    color: "rgba(0, 0, 0, 0.8)",
                    fontWeight: "400",
                    textAlign: "left",
                    fontSize: { xs: "16px", sm: "18px" },
                    fontFamily: "Outfit",
                    ...style,
                }}
            >
                {label}
                {required && (
                    <span style={{
                        color: "red"
                    }}>*</span>)}
            </Typography>
            {isLoading ? (
                <Skeleton height={60} />
            ) : (
                <TextField
                    sx={{
                        width: "100%",
                        mt: "10px",
                        "& .MuiOutlinedInput-notchedOutline ": {
                            outline: "none",
                            border: errors ? "2px solid red" : "none",
                        },
                        "& .MuiInputBase-root": {
                            borderRadius: "20px",
                            color: "rgba(0, 0, 0, 0.6)",
                            fontSize: "16px",
                            background: "rgba(239, 239, 239, 1)",
                            fontFamily: "Outfit",
                        },
                        ...sx,
                    }}
                    type={type === "password" ? (showPassword ? "text" : "password") : type}
                    placeholder={placeholder}
                    name={name}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    onKeyUp={onKeyUp}
                    multiline={multiline}
                    rows={rows}
                    onKeyDown={onKeyDown}
                    inputMode={inputMode}
                    min={min}
                    pattern={pattern}
                    disabled={disabled}
                    InputProps={{
                        maxLength: max,
                        endAdornment: type === "password" ? (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff sx={{ color: 'rgba(8, 85, 127, 1)' }} /> : <Visibility sx={{ color: 'rgba(8, 85, 127, 1)' }} />}
                                </IconButton>
                            </InputAdornment>
                        ) : null
                    }}
                />
            )}
            <Box sx={{ height: '18px' }}>
                {errors ? (
                    <Typography
                        sx={{
                            color: "red",
                            fontWeight: "400",
                            fontSize: { xs: "12px", sm: "12px" },
                            padding: '0 8px ',
                            margin: '0px'
                        }}
                    >
                        {errors}
                    </Typography>
                ) : null}
            </Box>
        </Box>
    );
};

export default CustomTextField;
